import React from "react";
import { motion } from "framer-motion";
import {
  Brain,
  Sparkles,
  Trophy,
  Wind,
  ShieldPlus,
  HeartPulse,
  Zap,
  Target,
  Flame,
  Anchor,
  Activity,
  Crown,
  Gem,
} from "lucide-react";
import { useLang } from "../i18n/LangContext";

const ICONS = [
  Brain,
  Sparkles,
  Trophy,
  Wind,
  ShieldPlus,
  HeartPulse,
  Zap,
  Target,
  Flame,
  Anchor,
  Activity,
  Crown,
  Gem,
];

export const Services = () => {
  const { t } = useLang();
  const items = t("services.items");

  return (
    <section
      id="leistungen"
      data-testid="section-services"
      className="relative py-24 lg:py-32 bg-[#050505] overflow-hidden"
    >
      <div className="red-glow" style={{ bottom: "-30%", right: "-25%", opacity: 0.4 }} />
      <div className="mx-auto max-w-[1400px] px-6 lg:px-12 relative">
        <div className="grid lg:grid-cols-12 gap-10 mb-16">
          <div className="lg:col-span-6">
            <div className="flex items-center gap-3 mb-6">
              <span className="h-px w-10 bg-primary-red" />
              <span className="text-[10px] font-bold uppercase tracking-[0.28em] text-zinc-400">
                {t("services.eyebrow")}
              </span>
            </div>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold text-white leading-[1.05] tracking-tight">
              {t("services.title")}
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 lg:gap-5">
          {items.map((it, i) => {
            const Icon = ICONS[i % ICONS.length];
            return (
              <motion.div
                key={i}
                data-testid={`service-${i}`}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.55, delay: (i % 4) * 0.06 }}
                className="group relative p-6 lg:p-8 bg-[#0a0a0a] border border-white/10 hover:border-primary-red/60 transition-colors duration-500"
              >
                <div className="w-11 h-11 flex items-center justify-center mb-6 border border-white/10 text-zinc-300 group-hover:border-primary-red group-hover:text-primary-red transition-colors">
                  <Icon size={18} strokeWidth={1.75} />
                </div>
                <h3 className="font-display text-lg lg:text-xl font-semibold text-white tracking-tight mb-2 pr-8 leading-snug break-words hyphens-auto">
                  {it.title}
                </h3>
                <p className="font-body text-xs lg:text-sm text-zinc-500 leading-relaxed">
                  {it.desc}
                </p>
                <div className="absolute top-4 right-5 text-[10px] font-bold text-zinc-700 tracking-widest">
                  {String(i + 1).padStart(2, "0")}
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
